var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0397D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9666 16.2104L33.7906 19.0331L30.9666 16.2104ZM32.7826 13.7238L25.1466 21.3598C24.7521 21.7538 24.483 22.2557 24.3733 22.8024L23.668 26.3331L27.1986 25.6264C27.7453 25.5171 28.2466 25.2491 28.6413 24.8544L36.2773 17.2184C36.5068 16.989 36.6888 16.7166 36.813 16.4168C36.9372 16.1169 37.0011 15.7956 37.0011 15.4711C37.0011 15.1466 36.9372 14.8253 36.813 14.5255C36.6888 14.2256 36.5068 13.9532 36.2773 13.7238C36.0478 13.4943 35.7754 13.3123 35.4756 13.1881C35.1758 13.0639 34.8545 13 34.53 13C34.2055 13 33.8841 13.0639 33.5843 13.1881C33.2845 13.3123 33.0121 13.4943 32.7826 13.7238V13.7238Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.334 29.0013V33.0013C34.334 33.7085 34.053 34.3868 33.5529 34.8869C33.0528 35.387 32.3746 35.668 31.6673 35.668H17.0007C16.2934 35.668 15.6151 35.387 15.115 34.8869C14.6149 34.3868 14.334 33.7085 14.334 33.0013V18.3346C14.334 17.6274 14.6149 16.9491 15.115 16.449C15.6151 15.9489 16.2934 15.668 17.0007 15.668H21.0007",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2114393febcb2358ac6923448cd4fb4d.svg";
export { ForwardRef as ReactComponent };